import {type MutationTree} from 'vuex';

const mutations: MutationTree<ModuleTaskState> = {
    error(state, error)
    {
        state.error = error;
    },
    update(state, payload)
    {
        state.error = null;

        for (let key in payload)
        {
            if (payload.hasOwnProperty(key))
            {
                state[key] = payload[key];
            }
        }
    },
};

export default mutations;